const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function buildHeaders(extra = {}) {
  const headers = { 'Content-Type': 'application/json', ...extra };
  const token = localStorage.getItem('auth_token');
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}

async function handleResponse(res) {
  if (res.status === 204) return null;

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text || null;
  }

  if (res.status === 401) {
    alert('Сессия истекла. Пожалуйста, войдите снова.');
    localStorage.removeItem('auth_token');

    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }

    throw new Error('Unauthorized');
  }

  if (!res.ok) {
    const message =
        (data && (data.detail || data.message || data.error)) ||
        res.statusText ||
        'Ошибка запроса';

    const error = new Error(message);
    error.status = res.status;
    error.data = data;
    throw error;
  }

  return data;
}



export async function apiGet(path) {
  const res = await fetch(`${API_BASE}${path}`, { method: 'GET', headers: buildHeaders(), credentials: 'include' });
  return handleResponse(res);
}

export async function apiPost(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(body),
    credentials: 'include' });
  return handleResponse(res);
}

export async function apiDelete(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'DELETE',
    headers: buildHeaders(),
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'include'
  });
  return handleResponse(res);
}


export function setToken(token) { if (token) localStorage.setItem('auth_token', token); }
export function clearToken() { localStorage.removeItem('auth_token'); }
export function getToken() { return localStorage.getItem('auth_token'); }

export async function apiUpload(path, formData) {
  const token = localStorage.getItem('auth_token');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers,
    body: formData,
    credentials: 'include',
  });
  return handleResponse(res);
}

